/**
 * Query keys del dominio Pedidos de láminas, segmentadas por sede activa.
 *
 * Keys consistentes y serializables (`docs/frontend_conventions.md`, Datos):
 * `['pedidos-laminas', ..., { sede }]`. Incluir la sede en la key **cachea por
 * sede**: al cambiar de sede, el tablero/historial/detalle se recargan (clave
 * distinta) en vez de mostrar los de la sede anterior. La sede activa la inyecta
 * `lib/api` como `X-Sede-Id`; aquí solo entra en la key para segmentar el cache.
 */

/** Raíz de todas las queries del dominio (para invalidación amplia). */
export const PEDIDOS_ROOT_KEY = ["pedidos-laminas"] as const;

/** Key del tablero, segmentada por sede. */
export function boardQueryKey(sedeId: number | null) {
  return ["pedidos-laminas", "board", { sede: sedeId }] as const;
}

/** Key del historial de recibidos, segmentada por sede. */
export function historialQueryKey(sedeId: number | null) {
  return ["pedidos-laminas", "historial", { sede: sedeId }] as const;
}

/** Key del detalle de un pedido, segmentada por sede. */
export function pedidoDetailQueryKey(sedeId: number | null, id: number) {
  return ["pedidos-laminas", "detail", { sede: sedeId, id }] as const;
}
